import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretRight, faCaretDown, faBars } from '@fortawesome/free-solid-svg-icons';

class SurescriptsProduct {
    constructor(init) {
        Object.assign(this, init);
        if (init && init.children && init.children.length > 0) {
            this.children = init.children.map(x => new SurescriptsProduct(x));
        }
    }
}

const _c0 = a0 => ({ active: a0 });
function ProductDropdownComponent_div_0_ng_container_5_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const i_r3 = ctx_r9.index;
    const p_r2 = ctx_r9.$implicit;
    i0.ɵɵpropertyInterpolate("id", "app-" + i_r3);
    i0.ɵɵpropertyInterpolate("href", p_r2.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, p_r2.selected));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(p_r2.text);
} }
const _c1 = () => ["fas", "caret-right"];
function ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 15);
} if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(1, _c1));
} }
const _c2 = () => ["fas", "caret-down"];
function ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_fa_icon_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 15);
} if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(1, _c2));
} }
function ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r15); const p_r2 = i0.ɵɵnextContext(2).$implicit; const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.toggleProductLevelCollapse(p_r2)); });
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_fa_icon_2_Template, 1, 2, "fa-icon", 14)(3, ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_fa_icon_3_Template, 1, 2, "fa-icon", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    const i_r3 = ctx_r16.index;
    const p_r2 = ctx_r16.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", "heading-" + i_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r2.isCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !p_r2.isCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", p_r2.text, " ");
} }
function ProductDropdownComponent_div_0_ng_container_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ProductDropdownComponent_div_0_ng_container_5_ng_template_2_div_0_Template, 5, 4, "div", 11);
} if (rf & 2) {
    const p_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", (p_r2.children == null ? null : p_r2.children.length) > 0);
} }
function ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    const j_r20 = ctx_r25.index;
    const c_r19 = ctx_r25.$implicit;
    const i_r3 = i0.ɵɵnextContext(2).index;
    i0.ɵɵpropertyInterpolate("id", "app-" + i_r3 + "-child-" + j_r20);
    i0.ɵɵpropertyInterpolate("href", c_r19.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, c_r19.selected));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(c_r19.text);
} }
function ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    const j_r20 = ctx_r27.index;
    const c_r19 = ctx_r27.$implicit;
    const i_r3 = i0.ɵɵnextContext(2).index;
    i0.ɵɵpropertyInterpolate("id", "heading-" + i_r3 + "-child-" + j_r20);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(c_r19.text);
} }
function ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_a_1_Template, 2, 6, "a", 17)(2, ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_ng_template_2_Template, 2, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const c_r19 = ctx.$implicit;
    const _r23 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", c_r19.link)("ngIfElse", _r23);
} }
function ProductDropdownComponent_div_0_ng_container_5_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, ProductDropdownComponent_div_0_ng_container_5_div_4_ng_container_1_Template, 4, 2, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngbCollapse", p_r2.isCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", p_r2.children);
} }
function ProductDropdownComponent_div_0_ng_container_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
} }
function ProductDropdownComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductDropdownComponent_div_0_ng_container_5_a_1_Template, 2, 6, "a", 6)(2, ProductDropdownComponent_div_0_ng_container_5_ng_template_2_Template, 1, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(4, ProductDropdownComponent_div_0_ng_container_5_div_4_Template, 2, 2, "div", 8)(5, ProductDropdownComponent_div_0_ng_container_5_div_5_Template, 1, 0, "div", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const _r6 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", p_r2.link)("ngIfElse", _r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (p_r2.children == null ? null : p_r2.children.length) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r3 + 1 != ctx_r1.products.length);
} }
const _c3 = () => ["fas", "bars"];
function ProductDropdownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "a", 2);
    i0.ɵɵtext(2, " MENU ");
    i0.ɵɵelement(3, "fa-icon", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, ProductDropdownComponent_div_0_ng_container_5_Template, 6, 4, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(2, _c3));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.products);
} }
/**
  * Example of usage:
  * <example-url>../assets/examples/shared/example-component-launch-sb.html?component=product-dropdown&version=9.0.2</example-url>
  */
class ProductDropdownComponent {
    constructor(http) {
        this.http = http;
    }
    ngOnInit() {
        let requestUrl;
        if (!this.ssoBaseUrl && !this.dataUrl) {
            // Set default to match backend middleware.
            requestUrl = "/shared/menu";
        }
        else if (!this.dataUrl) {
            console.warn("ssoBaseUrl is deprecated and has been replaced by dataUrl");
            this.ssoBaseUrl = this.ssoBaseUrl.replace(/\/+$/, '');
            requestUrl = `${this.ssoBaseUrl}/app/v1/user/menu`;
        }
        else {
            requestUrl = this.dataUrl;
        }
        this.http.get(requestUrl, { withCredentials: true }).pipe(map(resp => {
            const url = window.location.href.toLowerCase();
            let selected = [];
            const response = resp.map(x => {
                if (x.children && x.children.length > 0) {
                    selected = selected.concat(x.children.filter(y => y.link && url.startsWith(y.link.toLowerCase())));
                }
                else {
                    if (url.startsWith(x.link && x.link.toLowerCase())) {
                        selected = selected.concat(x);
                    }
                }
                return new SurescriptsProduct(x);
            });
            const longest = selected.length > 0 ? selected.reduce(function (a, b) { return a.link.length > b.link.length ? a : b; }) : null;
            let isChildSelected = false;
            return response.map(x => {
                x.isCollapsed = true;
                if (longest) {
                    if (x.children && x.children.length > 0) {
                        x.children.map(y => {
                            y.selected = y.text === longest.text && y.link === longest.link;
                            if (y.selected) {
                                isChildSelected = true;
                            }
                        });
                    }
                    if (isChildSelected) {
                        x.isCollapsed = false;
                        isChildSelected = false;
                    }
                    x.selected = x.text === longest.text && x.link === longest.link;
                }
                return x;
            });
        }), tap(resp => this.products = resp)).subscribe();
    }
    toggleProductLevelCollapse(p) {
        if (p.isCollapsed) {
            this.products.map(e => {
                e.isCollapsed = true;
                return e;
            });
        }
        p.isCollapsed = !p.isCollapsed;
    }
    static { this.ɵfac = function ProductDropdownComponent_Factory(t) { return new (t || ProductDropdownComponent)(i0.ɵɵdirectiveInject(i1.HttpClient)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductDropdownComponent, selectors: [["surescripts-product-dropdown"]], inputs: { ssoBaseUrl: "ssoBaseUrl", dataUrl: "dataUrl" }, decls: 1, vars: 1, consts: [["ngbDropdown", "", "display", "dynamic", 4, "ngIf"], ["ngbDropdown", "", "display", "dynamic"], ["ngbDropdownToggle", "", "data-toggle", "dropdown", 1, "nav-link", "font-weight-bold", "text-white"], [1, "mx-1", 3, "icon"], ["ngbDropdownMenu", ""], [4, "ngFor", "ngForOf"], ["class", "dropdown-item", 3, "id", "ngClass", "href", 4, "ngIf", "ngIfElse"], ["heading", ""], ["class", "", 3, "ngbCollapse", 4, "ngIf"], ["class", "dropdown-divider", 4, "ngIf"], [1, "dropdown-item", 3, "id", "ngClass", "href"], [3, "click", 4, "ngIf"], [3, "click"], [1, "dropdown-header", 3, "id"], ["class", "ms-2 text-primary me-2", 3, "icon", 4, "ngIf"], [1, "ms-2", "text-primary", "me-2", 3, "icon"], [1, "", 3, "ngbCollapse"], ["class", "dropdown-item ps-5", 3, "id", "ngClass", "href", 4, "ngIf", "ngIfElse"], ["childheading", ""], [1, "dropdown-item", "ps-5", 3, "id", "ngClass", "href"], [1, "dropdown-divider"]], template: function ProductDropdownComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProductDropdownComponent_div_0_Template, 6, 3, "div", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.products && ctx.products.length > 0);
        } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.NgbDropdown, i3.NgbDropdownToggle, i3.NgbDropdownMenu, i3.NgbCollapse, i1$1.FaIconComponent] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductDropdownComponent, [{
        type: Component,
        args: [{ selector: 'surescripts-product-dropdown', template: "<div ngbDropdown *ngIf=\"products && products.length > 0\" display=\"dynamic\">\n  <a ngbDropdownToggle class=\"nav-link font-weight-bold text-white\" data-toggle=\"dropdown\">\n    MENU\n    <fa-icon class=\"mx-1\"  [icon]=\"['fas', 'bars']\"></fa-icon>\n  </a>\n  <div ngbDropdownMenu>\n    <ng-container *ngFor=\"let p of products; index as i;\">\n        <a class=\"dropdown-item\" id=\"{{'app-'+i}}\" *ngIf=\"p.link; else heading\" [ngClass]=\"{active : p.selected}\" href=\"{{p.link}}\">{{p.text}}</a>\n        <ng-template #heading>\n          <div (click)=\"toggleProductLevelCollapse(p)\" *ngIf=\"p.children?.length > 0\">\n            <div class=\"dropdown-header\" id=\"{{'heading-'+i}}\">\n              <fa-icon  *ngIf=\"p.isCollapsed\" class=\"ms-2 text-primary me-2\"  [icon]=\"['fas', 'caret-right']\"></fa-icon>\n              <fa-icon  *ngIf=\"!p.isCollapsed\" class=\"ms-2 text-primary me-2\" [icon]=\"['fas', 'caret-down']\"></fa-icon>\n              {{p.text}}\n            </div>\n          </div>\n        </ng-template>\n      <div [ngbCollapse]=\"p.isCollapsed\" *ngIf=\"p.children?.length > 0\" class=\"\">\n        <ng-container *ngFor=\"let c of p.children; index as j;\">\n            <a class=\"dropdown-item ps-5\" id=\"{{'app-'+i+'-child-'+j}}\" *ngIf=\"c.link; else childheading\" [ngClass]=\"{active : c.selected}\" href=\"{{c.link}}\">{{c.text}}</a>\n            <ng-template #childheading>\n              <div class=\"dropdown-header\" id=\"{{'heading-'+i+'-child-'+j}}\">{{c.text}}</div>\n            </ng-template>\n        </ng-container>\n      </div>\n      <div class=\"dropdown-divider\" *ngIf=\"i+1 != products.length \"></div>\n    </ng-container>\n  </div>\n</div>\n" }]
    }], () => [{ type: i1.HttpClient }], { ssoBaseUrl: [{
            type: Input
        }], dataUrl: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductDropdownComponent, { className: "ProductDropdownComponent", filePath: "lib/product-dropdown.component.ts", lineNumber: 15 }); })();

class ProductDropdownModule {
    constructor(library) {
        library.addIcons(faCaretRight, faCaretDown, faBars);
    }
    static { this.ɵfac = function ProductDropdownModule_Factory(t) { return new (t || ProductDropdownModule)(i0.ɵɵinject(i1$1.FaIconLibrary)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProductDropdownModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            HttpClientModule,
            NgbDropdownModule,
            NgbCollapseModule,
            FontAwesomeModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    NgbDropdownModule,
                    NgbCollapseModule,
                    FontAwesomeModule
                ],
                declarations: [ProductDropdownComponent],
                exports: [ProductDropdownComponent]
            }]
    }], () => [{ type: i1$1.FaIconLibrary }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProductDropdownModule, { declarations: [ProductDropdownComponent], imports: [CommonModule,
        HttpClientModule,
        NgbDropdownModule,
        NgbCollapseModule,
        FontAwesomeModule], exports: [ProductDropdownComponent] }); })();

/*
 * Public API Surface of product-dropdown
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ProductDropdownComponent, ProductDropdownModule, SurescriptsProduct };
